import Company from '@/types/company'

function getCompanyKey(userId: number) {
  const COMPANY_KEY = `@atlas:company-by-user:${userId}`
  return COMPANY_KEY
}

export function getCompanyByUser(userId: number) {
  const COMPANY_KEY = getCompanyKey(userId)
  const company = localStorage.getItem(COMPANY_KEY)

  if (!company) return null

  return JSON.parse(company) as Company
}

export function setCompanyByUser(userId: number, company: Company) {
  const COMPANY_KEY = getCompanyKey(userId)
  localStorage.setItem(COMPANY_KEY, JSON.stringify(company))
}
